import React from 'react';
import { Button } from 'components/lib';
import Style from './table.tailwind.js';

export default function TableActions(props) {

  const row = props.row;

  return (
    <td key={props.index} className={Style.actions}>

      {row.actions?.custom?.map((action, i) => {

        if (action.condition) {

          return row[action.condition.col] === action.condition.value ?
            <Button key={i} icon={action.icon} iconOnly action={() => action.action(row)} className={Style.actionButton} tooltip={action.tooltip} /> : false;

        }

        return <Button key={i} icon={action.icon} iconOnly action={() => action.action(row)} className={Style.actionButton} tooltip={action.tooltip} />

      })}

      {row.actions.edit &&
        <Button icon='edit' iconOnly action={() => row.actions.edit(row, (res) => props.callback.edit(res, row))} className={Style.actionButton} tooltip='Edit' />}

      {row.actions.download &&
        <Button icon='download' iconOnly url={row.actions.download} className={Style.actionButton} tooltip='Download' />}

      {row.actions.view &&
        <Button icon='eye' iconOnly url={`${row.actions.view.url}/${row[row.actions.view.col]}`} className={Style.actionButton} tooltip='View' />}

      {row.actions.email &&
        <Button icon='mail' iconOnly action={() => window.location = `mailto:${row.email}`} className={Style.actionButton} tooltip='Email' />}

      {row.actions.invite &&
        <Button icon='mail' iconOnly action={e => row.actions.invite(row)} className={Style.actionButton} tooltip='Invite' />}

      {row.actions.delete &&
        <Button icon='trash' iconOnly action={() => row.actions.delete(row, (res) => props.callback.delete(res, row))} className={Style.actionButton} tooltip='Delete' />}

    </td>
  )
}